export default __webpack_public_path__ + "static/media/HDTX_Ringkasan Risalah_Minutes Summary EGMS 2025.e42605c7.pdf";